import Vue from 'vue'
import VueRouter from 'vue-router'

const EaseInOutQuad = (t, b, c, d) => {
  t /= d / 2
  if (t < 1) return c / 2 * t * t + b
  t--
  return -c / 2 * (t * (t - 2) - 1) + b
}
const ScrollToTop = (to = 0, duration = 350, scrollToDone = null) => {
  const element = document.documentElement
  const start = (window.pageYOffset || element.scrollTop) - (element.clientTop || 0)
  const change = to - start
  const increment = 20
  let currentTime = 0
  const animateScroll = () => {
    currentTime += increment
    const val = EaseInOutQuad(currentTime, start, change, duration)
    element.scrollTop = val
    if (currentTime < duration) {
      setTimeout(animateScroll, increment)
    } else {
      if (scrollToDone) scrollToDone()
    }
  }
  animateScroll()
}

export default function (app) {
  Vue.use(VueRouter)
  let isInit = false

  window.popStateDetected = false
  window.addEventListener('popstate', _ => {
    window.popStateDetected = true
  })

  let router = new VueRouter({
    mode: 'history',
    routes: [
      {
        path: '/',
        name: 'Home',
        redirect: { name: 'Dashboard' },
        component: () => import(/* webpackChunkName: 'Home' */ '@/Pages/Home'),
        meta: { label: 'dashboard' },
        children: [
          {
            path: 'profile',
            name: 'Profile',
            component: () => import(/* webpackChunkName: 'Profile' */ '@/Pages/Profile/Index'),
            meta: { label: 'profile', hide: true }
          },
          {
            path: 'dashboard',
            name: 'Dashboard',
            component: () => import(/* webpackChunkName: 'Dashboard' */ '@/Pages/Dashboard/Index'),
            meta: { label: 'dashboard', icon: 'dashboard' }
          },
          {
            path: 'companies',
            name: 'CompaniesParent',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'companies', icon: 'companies', permission: 'isAllowToViewCompanies' },
            children: [
              {
                path: 'index',
                name: 'Companies',
                component: () => import(/* webpackChunkName: 'Companies' */ '@/Pages/Companies_Companies/Index'),
                meta: { label: 'companies' }
              },
              {
                path: 'contacts',
                name: 'Contacts',
                component: () => import(/* webpackChunkName: 'Contacts' */ '@/Pages/Companies_Contacts/Index'),
                meta: { label: 'contacts' }
              },
              {
                path: 'shippers',
                name: 'Shippers',
                component: () => import(/* webpackChunkName: 'Shippers' */ '@/Pages/Companies_Shippers/Index'),
                meta: { label: 'shippers', permission: 'isAllowToViewShippers' }
              },
              {
                path: 'non-conformity-analyzes',
                name: 'NonConformityAnalyzes',
                component: () => import(/* webpackChunkName: 'NonConformityAnalyzes' */ '@/Pages/Companies_NonConformityAnalyzes/Index'),
                meta: { label: 'non-conformity-analyzes', permission: 'isAllowToViewNonConformityAnalyzes' }
              }
            ]
          },
          {
            path: 'stocks',
            name: 'StocksParent',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'part-editor', icon: 'stock', permission: 'isAllowToViewStocks' },
            children: [
              {
                path: 'index',
                name: 'Stocks',
                component: () => import(/* webpackChunkName: 'Stock' */ '@/Pages/Stock_Stock/Index'),
                meta: { label: 'stock' }
              },
              {
                path: 'parts',
                name: 'Parts',
                component: () => import(/* webpackChunkName: 'Parts' */ '@/Pages/Stock_Parts/Index'),
                meta: { label: 'parts', permission: 'isAllowToViewParts' }
              },
              {
                path: 'aircrafts',
                name: 'Aircrafts',
                component: () => import(/* webpackChunkName: 'Aircrafts' */ '@/Pages/Stock_Aircrafts/Index'),
                meta: { label: 'aircrafts', permission: 'isAllowToViewParts' }
              }
            ]
          },
          {
            path: 'rfq',
            name: 'RFQParent',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'rfq', icon: 'rfq', permission: 'isAllowToViewRFQs' },
            children: [
              {
                path: 'quick-rfq-part',
                name: 'RFQQuickRFQPartAvailable',
                component: () => import(/* webpackChunkName: 'QuickRFQPart' */ '@/Pages/RFQ_QuickRFQPartsAvailable'),
                meta: { label: 'quick-rfq-part', permission: 'isAllowToViewQuickRFQByParts' }
              },
              {
                path: 'quick-rfq-part-all',
                name: 'RFQQuickRFQPartAll',
                component: () => import(/* webpackChunkName: 'QuickRFQPart' */ '@/Pages/RFQ_QuickRFQPartsAll'),
                meta: { label: 'quick-rfq-part', permission: 'isAllowToViewQuickRFQByParts', hide: true }
              },
              {
                path: 'quick-rfq',
                name: 'RFQQuickRFQ',
                component: () => import(/* webpackChunkName: 'QuickRFQ' */ '@/Pages/RFQ_QuickRFQ/Index'),
                meta: { label: 'quick-rfq', permission: 'isAllowToViewRFQs,isAllowToEditRFQs' }
              },
              {
                path: 'index',
                name: 'RFQPendingRFQ',
                component: () => import(/* webpackChunkName: 'RFQPending' */ '@/Pages/RFQ_RFQPending/Index'),
                meta: { label: 'rfq-pending' }
              },
              {
                path: 'quick-rfq-2',
                name: 'RFQQuickRFQ2',
                component: () => import(/* webpackChunkName: 'QuickRFQ2' */ '@/Pages/RFQ_QuickRFQ2/Index'),
                meta: { label: 'quick-rfq-2', permission: 'isAllowToViewRFQs,isAllowToEditRFQs' }
              },
              {
                path: 'rfq2-list',
                name: 'RFQ2List',
                component: () => import(/* webpackChunkName: 'RFQ2List' */ '@/Pages/RFQ_RFQ2List/Index'),
                meta: { label: 'rfq2-list', permission: 'isAllowToViewRFQs' }
              }
            ]
          },
          {
            path: 'customer-order',
            name: 'CustomerOrder',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'customer-order', icon: 'customer-order', permission: 'isAllowToViewCustomerOrders' },
            children: [
              {
                path: 'index',
                name: 'CustomerPoOpen',
                component: () => import(/* webpackChunkName: 'CustomerPoOpen' */ '@/Pages/RFQ_CustomerPoOpen/Index'),
                meta: { label: 'customer-po-open' }
              },
              {
                path: 'customer-po-close',
                name: 'CustomerPoClose',
                component: () => import(/* webpackChunkName: 'CustomerPoClose' */ '@/Pages/RFQ_CustomerPoClose/Index'),
                meta: { label: 'customer-po-close' }
              },
              {
                path: 'purchase',
                name: 'Purchase',
                component: () => import(/* webpackChunkName: 'RFQPurchase' */ '@/Pages/RFQ_Purchase/Index'),
                meta: { label: 'purchase-order', permission: 'isAllowToEditRFQs' }
              },
              {
                path: 'customer-po-followup',
                name: 'CustomerPoFollowup',
                component: () => import(/* webpackChunkName: 'CustomerPoFollowup' */ '@/Pages/RFQ_CustomerPoFollowup/Index'),
                meta: { label: 'customer-po-followup', permission: 'isAllowToViewRFQs' }
              },
              {
                path: 'rfq-repair-td',
                name: 'RFQRepairTD',
                component: () => import(/* webpackChunkName: 'RFQRepairTD' */ '@/Pages/RFQ_RepairTD/Index'),
                meta: { label: 'rfq-repair-td', permission: 'isAllowToViewRFQs' }
              },
              {
                path: 'rfq-exchange-td',
                name: 'RFQ_ExchangeTD',
                component: () => import(/* webpackChunkName: 'RFQExchangeTD' */ '@/Pages/RFQ_ExchangeTD/Index'),
                meta: { label: 'rfq-exchange-td', permission: 'isAllowToViewRFQs' }
              },
              {
                path: 'invoices',
                name: 'CustomerInvoices',
                component: () => import(/* webpackChunkName: 'Invoices' */ '@/Pages/Finance_Invoices/Index'),
                meta: { label: 'invoices', permission: 'isAllowToViewCustomerOrders' }
              },
              {
                path: 'customers-by-sales',
                name: 'RFQ_CustomersBySales',
                component: () => import(/* webpackChunkName: 'CustomerBySales' */ '@/Pages/RFQ_CustomerBySales/Index'),
                meta: { label: 'customers-by-sale', permission: 'isAllowToViewCustomerOrders' }
              }
            ]
          },
          {
            path: 'supplier-order',
            name: 'SupplierOrder',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'supplier-order', icon: 'supplier-order', permission: 'isAllowToViewSupplierOrders' },
            children: [
              {
                path: 'index',
                name: 'SupplierQuickRFQ2',
                component: () => import(/* webpackChunkName: 'QuickRFQ2' */ '@/Pages/RFQ_QuickRFQ2/Index'),
                meta: { label: 'quick-rfq-2', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-quotes-rfq2-chosen-false',
                name: 'SupplierQuotesRFQ2ChosenFalse',
                component: () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ '@/Pages/RFQ_SupplierQuotesRFQ2/Index'),
                meta: { label: 'supplier-quotes-rfq2', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'po-wo-customer-po-open',
                name: 'PoWoBasedOnCustomerPoOpen',
                component: () => import(/* webpackChunkName: 'PoWoBasedOnCustomerPoOpen' */ '@/Pages/RFQ_PoWoBasedOnCustomerPoOpen'),
                meta: { label: 'create-po-wo-by-customer-po', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-po-wo-open',
                name: 'SupplierPoWoOpen',
                component: () => import(/* webpackChunkName: 'RFQSupplierPoWo' */ '@/Pages/RFQ_SupplierPoWoOpen'),
                meta: { label: 'supplier-po-wo-open', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-po-wo-analytics-open',
                name: 'SupplierPoWoAnalyticsOpen',
                component: () => import(/* webpackChunkName: 'RFQSupplierPoWoAnalytics' */ '@/Pages/RFQ_SupplierPoWoAnalyticsOpen'),
                meta: { label: 'supplier-po-wo-analytics-open', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-po-wo-close',
                name: 'SupplierPoWoClose',
                component: () => import(/* webpackChunkName: 'RFQSupplierPoWo' */ '@/Pages/RFQ_SupplierPoWoClose'),
                meta: { label: 'supplier-po-wo-close', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-po-wo-analytics-close',
                name: 'SupplierPoWoAnalyticsClose',
                component: () => import(/* webpackChunkName: 'RFQSupplierPoWoAnalytics' */ '@/Pages/RFQ_SupplierPoWoAnalyticsClose'),
                meta: { label: 'supplier-po-wo-analytics-close', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-rfq-repair-td',
                name: 'SupplierRFQRepairTD',
                component: () => import(/* webpackChunkName: 'RFQRepairTD' */ '@/Pages/RFQ_RepairTD/Index'),
                meta: { label: 'rfq-repair-td', permission: 'isAllowToViewSupplierOrders' }
              },
              {
                path: 'supplier-rfq-repair-td-archive',
                name: 'SupplierRFQRepairTDArchive',
                component: () => import(/* webpackChunkName: 'RFQRepairTDArchive' */ '@/Pages/RFQ_RepairTDArchive/Index'),
                meta: { label: 'rfq-repair-td-archive', permission: 'isAllowToViewSupplierOrders' }
              }
            ]
          },
          {
            path: 'support',
            name: 'Support',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'support', icon: 'support', permission: 'isAllowToViewSupport' },
            children: [
              {
                path: 'index',
                name: 'SupportQuickRFQ2',
                component: () => import(/* webpackChunkName: 'QuickRFQ2' */ '@/Pages/RFQ_QuickRFQ2/Index'),
                meta: { label: 'quick-rfq-2', permission: 'isAllowToViewSupport' }
              },
              {
                path: 'support-open-wo',
                name: 'SupportOpenWO',
                component: () => import(/* webpackChunkName: 'OpenWO' */ '@/Pages/RFQ_OpenWO/Index'),
                meta: { label: 'open-wo', permission: 'isAllowToViewSupport' }
              },
              {
                path: 'support-open-wo-review',
                name: 'SupportOpenWOReview',
                component: () => import(/* webpackChunkName: 'OpenWOReview' */ '@/Pages/RFQ_OpenWOReview/Index'),
                meta: { label: 'open-wo-review', permission: 'isAllowToViewSupport' }
              },
              {
                path: 'support-open-po',
                name: 'SupportOpenPO',
                component: () => import(/* webpackChunkName: 'OpenPO' */ '@/Pages/RFQ_OpenPO/Index'),
                meta: { label: 'open-po', permission: 'isAllowToViewRFQs,isAllowToEditRFQs' }
              },
              {
                path: 'support-open-po-review',
                name: 'SupportOpenPOReview',
                component: () => import(/* webpackChunkName: 'OpenPOReview' */ '@/Pages/RFQ_OpenPOReview/Index'),
                meta: { label: 'open-po-review', permission: 'isAllowToViewSupport' }
              },
              {
                path: 'support-customer-po-followup',
                name: 'SupportCustomerPoFollowup',
                component: () => import(/* webpackChunkName: 'SupportCustomerPoFollowupReview' */ '@/Pages/RFQ_CustomerPoFollowup/Index'),
                meta: { label: 'customer-po-followup', permission: 'isAllowToViewRFQs' }
              },
              {
                path: 'support-customer-po-followup-review',
                name: 'SupportCustomerPoFollowupReview',
                component: () => import(/* webpackChunkName: 'SupportCustomerPoFollowupReview' */ '@/Pages/RFQ_CustomerPoFollowupReview/Index'),
                meta: { label: 'customer-po-followup-review', permission: 'isAllowToViewRFQs' }
              }
            ]
          },
          {
            path: 'qi',
            name: 'QI',
            component: () => import(/* webpackChunkName: 'QI' */ '@/Pages/QI/Index'),
            meta: { label: 'qi', icon: 'qi', permission: 'isAllowToViewQIs' }
          },
          {
            path: 'finance',
            name: 'Finance',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: { label: 'finance', icon: 'finance', permission: 'isAllowToViewFinance' },
            children: [
              {
                path: 'payments',
                name: 'Payments',
                component: () => import(/* webpackChunkName: 'Payments' */ '@/Pages/Finance_Payments/Index'),
                meta: { label: 'payments' }
              },
              {
                path: 'payment-logs',
                name: 'PaymentLogs',
                component: () => import(/* webpackChunkName: 'PaymentLogs' */ '@/Pages/Finance_Payments_Logs/Index'),
                meta: { label: 'payment-logs' }
              },
              {
                path: 'invoices',
                name: 'Invoices',
                component: () => import(/* webpackChunkName: 'Invoices' */ '@/Pages/Finance_Invoices/Index'),
                meta: { label: 'invoices' }
              }
            ]
          },
          {
            path: 'settings',
            name: 'SettingsParent',
            component: () => import(/* webpackChunkName: 'SettingsParent' */ '@/Pages/Inner'),
            meta: { label: 'settings', icon: 'settings', permission: 'isAllowToViewSettings' },
            children: [
              {
                path: 'users-management',
                name: 'UsersManagement',
                component: () => import(/* webpackChunkName: 'UsersManagement' */ '@/Pages/Settings_UsersManagement/Index'),
                meta: { label: 'users-management' }
              },
              {
                path: 'employees',
                name: 'Employees',
                component: () => import(/* webpackChunkName: 'Employees' */ '@/Pages/Settings_Employees/Index'),
                meta: { label: 'employees' }
              },
              {
                path: 'global-settings',
                name: 'GlobalParameters',
                component: () => import(/* webpackChunkName: 'GlobalParameters' */ '@/Pages/Settings_GlobalParameters/Index'),
                meta: { label: 'global-settings' }
              },
              {
                path: 'links',
                name: 'Links',
                component: () => import(/* webpackChunkName: 'Links' */ '@/Pages/Settings_Links/Index'),
                meta: { label: 'links' }
              },
              {
                path: 'labels',
                name: 'Labels',
                component: () => import(/* webpackChunkName: 'Labels' */ '@/Pages/Settings_Labels/Index'),
                meta: { label: 'labels' }
              },
              {
                path: 'permissions',
                name: 'Permissions',
                component: () => import(/* webpackChunkName: 'Permissions' */ '@/Pages/Settings_Permissions/Index'),
                meta: { label: 'permissions' }
              },
              {
                path: 'contents',
                name: 'Contents',
                component: () => import(/* webpackChunkName: 'Contents' */ '@/Pages/Settings_Contents/Index'),
                meta: { label: 'contents' }
              }
            ]
          },
          {
            path: 'technical-settings',
            name: 'TechnicalSettingsParent',
            component: () => import(/* webpackChunkName: 'Inner' */ '@/Pages/Inner'),
            meta: {
              label: 'technical-settings',
              icon: 'technical-settings',
              permission: 'isAllowToViewTechnicalSettings'
            },
            children: [
              {
                path: 'certs',
                name: 'Certs',
                component: () => import(/* webpackChunkName: 'Certs' */ '@/Pages/TS_Certs/Index'),
                meta: { label: 'certs' }
              },
              {
                path: 'company-remark-subjects',
                name: 'CompanyRemarkSubjects',
                component: () => import(/* webpackChunkName: 'CompanyRemarkSubjects' */ '@/Pages/TS_CompanyRemarkSubjects/Index'),
                meta: { label: 'company-remark-subjects' }
              },
              {
                path: 'company-types',
                name: 'CompanyTypes',
                component: () => import(/* webpackChunkName: 'CompanyTypes' */ '@/Pages/TS_CompanyTypes/Index'),
                meta: { label: 'company-types' }
              },
              {
                path: 'conditions',
                name: 'Conditions',
                component: () => import(/* webpackChunkName: 'Conditions' */ '@/Pages/TS_Conditions/Index'),
                meta: { label: 'conditions' }
              },
              {
                path: 'currencies',
                name: 'Currencies',
                component: () => import(/* webpackChunkName: 'Currencies' */ '@/Pages/TS_Currencies/Index'),
                meta: { label: 'currencies' }
              },
              {
                path: 'divisions',
                name: 'Divisions',
                component: () => import(/* webpackChunkName: 'Divisions' */ '@/Pages/TS_Divisions/Index'),
                meta: { label: 'divisions' }
              },
              {
                path: 'methods',
                name: 'Methods',
                component: () => import(/* webpackChunkName: 'Methods' */ '@/Pages/TS_Methods/Index'),
                meta: { label: 'methods' }
              },
              {
                path: 'priorities',
                name: 'Priorities',
                component: () => import(/* webpackChunkName: 'Priorities' */ '@/Pages/TS_Priorities/Index'),
                meta: { label: 'priorities' }
              },
              {
                path: 'ratings',
                name: 'Ratings',
                component: () => import(/* webpackChunkName: 'Ratings' */ '@/Pages/TS_Ratings/Index'),
                meta: { label: 'ratings' }
              },
              {
                path: 'regions',
                name: 'Regions',
                component: () => import(/* webpackChunkName: 'Regions' */ '@/Pages/TS_Regions/Index'),
                meta: { label: 'regions' }
              },
              {
                path: 'releases',
                name: 'Releases',
                component: () => import(/* webpackChunkName: 'Releases' */ '@/Pages/TS_Releases/Index'),
                meta: { label: 'releases' }
              },
              {
                path: 'rfq-types',
                name: 'RFQTypes',
                component: () => import(/* webpackChunkName: 'RFQTypes' */ '@/Pages/TS_RFQTypes/Index'),
                meta: { label: 'rfq-types' }
              },
              {
                path: 'scores',
                name: 'Scores',
                component: () => import(/* webpackChunkName: 'Scores' */ '@/Pages/TS_Scores/Index'),
                meta: { label: 'scores' }
              },
              {
                path: 'statuses',
                name: 'Statuses',
                component: () => import(/* webpackChunkName: 'Statuses' */ '@/Pages/TS_Statuses/Index'),
                meta: { label: 'statuses' }
              },
              {
                path: 'stock-locations',
                name: 'StockLocations',
                component: () => import(/* webpackChunkName: 'StockLocations' */ '@/Pages/TS_StockLocations/Index'),
                meta: { label: 'stock-locations' }
              },
              {
                path: 'stock-sales-remarks',
                name: 'StockSalesRemarks',
                component: () => import(/* webpackChunkName: 'StockSalesRemarks' */ '@/Pages/TS_StockSalesRemarks/Index'),
                meta: { label: 'stock-sales-remarks' }
              },
              {
                path: 'vats',
                name: 'VATs',
                component: () => import(/* webpackChunkName: 'VATs' */ '@/Pages/TS_VATs/Index'),
                meta: { label: 'vats' }
              },
              {
                path: 'non-conformity-origin',
                name: 'NonConformityOrigin',
                component: () => import(/* webpackChunkName: 'NonConformityOrigin' */ '@/Pages/TS_NonConformityOrigin/Index'),
                meta: { label: 'non-conformity-origin' }
              },
              {
                path: 'non-conformity-nature',
                name: 'NonConformityNature',
                component: () => import(/* webpackChunkName: 'NonConformityNature' */ '@/Pages/TS_NonConformityNature/Index'),
                meta: { label: 'non-conformity-nature' }
              },
              {
                path: 'non-conformity-action',
                name: 'NonConformityAction',
                component: () => import(/* webpackChunkName: 'NonConformityAction' */ '@/Pages/TS_NonConformityAction/Index'),
                meta: { label: 'non-conformity-action' }
              },
              {
                path: 'non-conformity-dysfunction',
                name: 'NonConformityDysfunction',
                component: () => import(/* webpackChunkName: 'NonConformityDysfunction' */ '@/Pages/TS_NonConformityDysfunction/Index'),
                meta: { label: 'non-conformity-dysfunction' }
              },
              {
                path: 'non-conformity-dysfunction-detail',
                name: 'NonConformityDysfunctionDetail',
                component: () => import(/* webpackChunkName: 'NonConformityDysfunctionDetail' */ '@/Pages/TS_NonConformityDysfunctionDetail/Index'),
                meta: { label: 'non-conformity-dysfunction-detail' }
              },
              {
                path: 'banks',
                name: 'Banks',
                component: () => import(/* webpackChunkName: 'Banks' */ '@/Pages/TS_Banks/Index'),
                meta: { label: 'banks' }
              },
              {
                path: 'order-type-commissions',
                name: 'OrderTypeCommissions',
                component: () => import(/* webpackChunkName: 'OrderTypeCommissions' */ '@/Pages/TS_OrderTypeCommissions/Index'),
                meta: { label: 'order-type-commissions' }
              },
              {
                path: 'order-phases',
                name: 'OrderPhases',
                component: () => import(/* webpackChunkName: 'OrderPhases' */ '@/Pages/TS_OrderPhases/Index'),
                meta: { label: 'order-phases' }
              },
              {
                path: 'invoice-types',
                name: 'InvoiceTypes',
                component: () => import(/* webpackChunkName: 'InvoiceTypes' */ '@/Pages/TS_InvoiceTypes/Index'),
                meta: { label: 'invoice-types' }
              },
              {
                path: 'invoice-sources',
                name: 'InvoiceSources',
                component: () => import(/* webpackChunkName: 'InvoiceSources' */ '@/Pages/TS_InvoiceSources/Index'),
                meta: { label: 'invoice-sources' }
              }
            ]
          },
          {
            path: 'bi',
            name: 'BI',
            component: () => import(/* webpackChunkName: 'BI' */ '@/Pages/BI/Index'),
            meta: { label: 'bi', icon: 'bi', permission: 'isAllowToViewBIs' },
            beforeEnter: (to, from, next) => {
              if (from.name) window.location.href = window.location.origin + to.fullPath; else next()
            },
            beforeLeave: (to) => {
              window.location.href = window.location.origin + to.fullPath
            }
          }
        ]
      },
      {
        path: '/login',
        name: 'Login',
        component: () => import(/* webpackChunkName: 'Login' */ '@/Pages/Login/Index')
      },
      {
        path: '*',
        name: 'Page404',
        component: () => import(/* webpackChunkName: '404' */ '@/Pages/Page404'),
        meta: { label: 'page-404' }
      }
    ]
  })

  router.beforeEach((to, from, next) => {
    // TODO: popstate
    let isBackButton = window.popStateDetected
    // TODO: Login
    if (to.name === 'Login') {
      next()
    } else {
      app.store
        .dispatch('checkLogged')
        .then(_ => {
          if (to.name !== 'Dashboard') {
            let from_ = (
              !isBackButton &&
              isInit &&
              from.name !== to.name &&
              !['Dashboard', 'SingUp', 'EditPreferences', 'Login', 'Page404'].includes(from.name) &&
              !['SingUp', 'EditPreferences', 'Login', 'Page404'].includes(to.name)
            ) ? from : null
            if (from_) app.store.state.routeFrom.push(from_)
          } else {
            app.store.state.routeFrom = []
          }
          if (to.name !== from.name) ScrollToTop()
          next()
          isInit = true
        })
        .catch(_ => {
          next({ name: 'Login', params: { nextUrl: to.fullPath } })
        })
    }
    window.popStateDetected = false
  })
  app.router = router
}
